import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { TargetPlatform } from "../../../shared/types/TargetPlatform";
import { targetPlatformOptions } from "./TargetPlatformOptions";

type TargetPlatformSelectorProps = {
    value: TargetPlatform;
    onValueChange: (newValue: TargetPlatform) => void;
    disabled?: boolean;
};

export function TargetPlatformSelector({
    value,
    onValueChange,
    disabled,
}: TargetPlatformSelectorProps) {
    const handleChange = (event: SelectChangeEvent<string>): void => {
        onValueChange(TargetPlatform[event.target.value as keyof typeof TargetPlatform]);
    };

    return (
        <FormControl
            variant="standard"
            sx={{ width: 155 }}
            disabled={disabled}
        >
            <InputLabel id="target-platform-label">
                Target platform
            </InputLabel>
            <Select
                labelId="target-platform-label"
                id="targetPlatform"
                size="small"
                value={TargetPlatform[value]}
                onChange={handleChange}
                sx={{
                    "& .MuiInputBase-input": {
                        paddingBottom: '2px',
                    },
                }}
            >
                {targetPlatformOptions.map(option => (
                    <MenuItem key={option.value} value={option.name}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
